(function () {
  function initGallery(root) {
    var track = root.querySelector('.vt-gallery__track');
    var dots = root.querySelectorAll('.vt-gallery__dot');
    var thumbs = root.querySelectorAll('.vt-gallery__thumb');
    if (!track) return;
    var slides = track.querySelectorAll('.vt-gallery__slide');

    function setActive(i) {
      dots.forEach(function (d, idx) { d.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
      thumbs.forEach(function (t, idx) { t.setAttribute('aria-current', idx === i ? 'true' : 'false'); });
    }
    function goTo(i) {
      var slide = slides[i];
      if (slide) track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
    }
    dots.forEach(function (d, idx) { d.addEventListener('click', function () { goTo(idx); }); });
    thumbs.forEach(function (t, idx) { t.addEventListener('click', function () { goTo(idx); }); });
    var ticking = false;
    track.addEventListener('scroll', function () {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function () {
        var i = Math.round(track.scrollLeft / track.clientWidth);
        setActive(Math.min(i, slides.length - 1));
        ticking = false;
      });
    });
  }

  function initAccordion(root) {
    root.querySelectorAll('.vt-faq__item').forEach(function (item) {
      var btn = item.querySelector('.vt-faq__btn');
      btn.addEventListener('click', function () {
        var open = item.getAttribute('data-open') === 'true';
        root.querySelectorAll('.vt-faq__item').forEach(function (i) { i.setAttribute('data-open', 'false'); });
        item.setAttribute('data-open', open ? 'false' : 'true');
      });
    });
  }

  function initSticky(root) {
    var bar = root.querySelector('.vt-sticky');
    var buyBox = root.querySelector('.vt-info');
    if (!bar || !buyBox) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        bar.classList.toggle('is-visible', !entry.isIntersecting && entry.boundingClientRect.top < 0);
      });
    }, { threshold: 0 });
    io.observe(buyBox);
  }

  function initLightbox(root) {
    var slides = root.querySelectorAll('.vt-gallery__slide img');
    if (!slides.length) return;
    var box = document.createElement('div');
    box.className = 'vt-lightbox';
    box.innerHTML = '<button type="button" class="vt-lightbox__arrow vt-lightbox__arrow--prev" aria-label="Anterior"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M15 6l-6 6 6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<img class="vt-lightbox__img" alt="">' +
      '<button type="button" class="vt-lightbox__arrow vt-lightbox__arrow--next" aria-label="Siguiente"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"><path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg></button>' +
      '<button type="button" class="vt-lightbox__close" aria-label="Cerrar"><svg width="18" height="18" viewBox="0 0 24 24" fill="none"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg></button>';
    document.body.appendChild(box);
    var img = box.querySelector('.vt-lightbox__img');
    var current = 0;
    function show(i) {
      current = (i + slides.length) % slides.length;
      var src = slides[current].getAttribute('data-zoom') || slides[current].src;
      img.src = src;
      img.alt = slides[current].alt;
    }
    function open(i) { show(i); box.classList.add('is-open'); }
    function close() { box.classList.remove('is-open'); }
    slides.forEach(function (s, idx) { s.addEventListener('click', function () { open(idx); }); });
    box.querySelector('.vt-lightbox__close').addEventListener('click', close);
    box.querySelector('.vt-lightbox__arrow--prev').addEventListener('click', function () { show(current - 1); });
    box.querySelector('.vt-lightbox__arrow--next').addEventListener('click', function () { show(current + 1); });
    box.addEventListener('click', function (e) { if (e.target === box) close(); });
    document.addEventListener('keydown', function (e) {
      if (!box.classList.contains('is-open')) return;
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowLeft') show(current - 1);
      if (e.key === 'ArrowRight') show(current + 1);
    });
  }

  function initCountdown(root) {
    var el = root.querySelector('[data-vt-countdown]');
    if (!el) return;
    function pad(n) { return String(n).padStart(2, '0'); }
    function tick() {
      var now = new Date();
      var end = new Date(now);
      end.setHours(24, 0, 0, 0);
      var diff = Math.max(0, end - now);
      var h = Math.floor(diff / 3600000);
      var m = Math.floor((diff % 3600000) / 60000);
      var s = Math.floor((diff % 60000) / 1000);
      el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
    }
    tick();
    setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('[data-vt-scu]').forEach(function (root) {
      initGallery(root);
      initAccordion(root);
      initSticky(root);
      initLightbox(root);
      initCountdown(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
